import type { FaireProductEntity } from "../../entity_types/product";

export const p_94t4x4uhpf: FaireProductEntity = {
  token: "p_94t4x4uhpf",
  type: "product",
  name: "Gold or Silver Dainty LOVE Monogram Charm CPG-CPS055",
  brandToken: "b_gcccr7fgc5",
  brandName: "Jewel Pledge",
  imageUrl:
    "https://cdn.faire.com/fastly/5b8100c0f709f04a9e08fa99c833312176113244d6fed95014bcc84842cdc598.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/70490d2822384aa32684eb1f66c446d5dcd4f836e29432f057f96565257aefcf.jpeg",
    "https://cdn.faire.com/fastly/70fb06a884754eb8b6372bb8d8ccf4744c4f167df1b055239f508e4c43da2cbc.jpeg",
    "https://cdn.faire.com/fastly/bb1534c34a9acc2a0d08116878ae22d5afc9b642a5ac1bd880cf03571b15a0a2.jpeg",
  ],
  priceDollars: 2,
  description:
    "18K Gold or Silver LOVE Monogram Charm,High Polished Shiny, 1 pc,5pcs or 10 pcs CPG-CPS055\nThis listing is for one single piece.\n\nMeasurement:20mm x 4mm\nThickness: 1.2mm\nMaterial:18k gold plated or rhodium plated over brass\nOpen jump ring,hole:2.7mm inside diameter.\n\nVariations: gold or silver\nLead, Cadmium and nickel free\nQuantity discount available at drop down menu**\nShip From Los Angeles",
  tags: [],
  msrpDollars: 4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-21T22:11:59.230Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
